import { Button, Drawer } from 'antd';
import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  {
    // name: 'Dự đoán',
    href: '/',
    icon: '/assets/images/header/btn_dudoan.png',
    iconActive: '/assets/images/header/btn_dudoan_active.png'
  },
  {
    // name: 'Thể lệ',
    href: '/rule',
    icon: '/assets/images/header/btn_thele.png',
    iconActive: '/assets/images/header/btn_thele_active.png'
  },
  {
    // name: 'Kết quả',
    href: '/prize-structure',
    icon: '/assets/images/header/btn_ketqua.png',
    iconActive: '/assets/images/header/btn_ketqua_active.png'
  }
];

const HeaderMenu = () => {
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const location = useLocation();
  const activeNav = location.pathname;
  const mounted = useRef(false);
  const [isShowMenu, setIsShowMenu] = useState(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.HI88
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full"
        style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)' }}
      >
        <div
          className="flex flex-row justify-between items-center w-full max-w-[1200px] mx-auto px-[8px] md:px-[26px] py-[8px] md:py-[13px] gap-[5px] md:gap-[10px] 
             h-[60px] md:h-[80px]"
        >
          <div className="flex md:hidden justify-start w-full md:w-1/5">
            <Drawer
              placement="left"
              onClose={() => setIsShowMenu(false)}
              open={isShowMenu}
              closeIcon={null}
              width={260}
              bodyStyle={{ padding: 0, position: 'relative' }}
              style={{
                // Hide scrollbar for the Drawer
                overflow: 'auto',
                scrollbarWidth: 'none', // For Firefox
                msOverflowStyle: 'none', // For IE, Edge
                background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)'
              }}
              // For Ant Design Drawer: pass className to customize scrollbar for inner content
              className="drawer-hide-scrollbar"
            >
              {/* Inline scrollbar-hide CSS for injected content */}
              <style>
                {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
              </style>
              {/* Logo on Top */}
              <div
                className="flex items-center justify-center w-full py-6 border-b border-gray-200"
                // style={{ background: '#26A9E0' }}
              >
                <Link to="/" onClick={() => setIsModalHistory(false)}>
                  <img
                    src="/assets/images/header/logo.png"
                    alt="Logo"
                    className="h-[48px] w-auto object-contain mx-auto"
                  />
                </Link>
              </div>
              {/* Close Button X */}
              <button
                onClick={() => setIsShowMenu(false)}
                className="absolute top-3 right-3 z-10 text-grayhover:text-gray-400 transition-colors"
                aria-label="Đóng menu"
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: 32,
                  lineHeight: 1,
                  cursor: 'pointer'
                }}
              >
                ×
              </button>
              {/* Hide scrollbar for this menu list as well */}
              <div
                className="flex flex-col h-full"
                // style={{ background: '#26A9E0', overflow: 'auto' }}
                style={{ background: 'linear-gradient(180deg, #FFFFFF 0%, #C5EEFF 100%)' }}
              >
                <Link
                  to="/"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Dự đoán
                </Link>
                <Link
                  to="/rule"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Thể lệ
                </Link>
                <Link
                  to="/prize-structure"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                >
                  Kết quả
                </Link>
                <Button
                  type="text"
                  className="flex items-center justify-start px-5 py-8 font-bold text-xl w-full text-left text-[#26A9E0] transition-colors group"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsModalHistory(true);
                  }}
                  style={{ color: '#26A9E0', background: 'transparent', border: 'none' }}
                >
                  <span className="group-hover:text-yellow-300 group-hover:bg-blue-800 w-full block transition-colors">
                    Lịch sử
                  </span>
                </Button>
                <Link
                  to={settings.link_login}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                >
                  Đăng nhập
                </Link>
                <Link
                  to={settings.link_register}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-5 py-4 border-b border-blue-900 hover:bg-blue-800 hover:text-yellow-300 font-bold text-xl text-[#26A9E0] transition-colors"
                  onClick={() => {
                    setIsModalHistory(false);
                    setIsShowMenu(false);
                  }}
                >
                  Đăng ký
                </Link>
              </div>
            </Drawer>
            <Button type="link" onClick={() => setIsShowMenu(true)}>
              <img
                src="/assets/images/header/menu.png"
                alt=""
                className="h-[32px] w-[32px] md:w-auto object-contain"
              />
            </Button>
          </div>
          <div className="flex justify-start w-full mt-2">
            <Link
              to={'/'}
              onClick={() => {
                setIsModalHistory(false);
                setIsShowMenu(false);
              }}
            >
              <img
                src="/assets/images/header/logo.png"
                alt=""
                className="h-[52px] md:h-[72px] w-auto object-contain"
              />
            </Link>
          </div>

          <div
            className="flex justify-end items-center w-full hide-scrollbar"
            style={{
              height: '100vh',
              overflowY: 'auto'
            }}
          >
            {/* Hide native scrollbar for both Webkit and Firefox */}
            <style>
              {`
                .hide-scrollbar {
                  scrollbar-width: none; /* Firefox */
                  -ms-overflow-style: none;  /* IE and Edge */
                }
                .hide-scrollbar::-webkit-scrollbar {
                  display: none; /* Chrome, Safari and Opera */
                  width: 0 !important;
                  background: transparent !important;
                }
              `}
            </style>
            <Link
              to={settings.link_home}
              target="_blank"
              className="md:hidden w-[90px] h-[90px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/home.png"
                alt="Đăng nhập"
                className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
            <div className="hidden md:flex flex-row items-center justify-end gap-2 w-full h-full">
              <Link
                to={settings.link_login}
                target="_blank"
                className="w-[90px] h-[26px] md:w-[118px] md:h-[33px] flex items-center justify-center"
              >
                <img
                  src="/assets/images/header/login.png"
                  alt="Đăng nhập"
                  className="max-w-full max-h-full object-contain transition-all transform duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
                />
              </Link>
              <Link
                to={settings.link_register}
                target="_blank"
                className="w-[90px] h-[26px] md:w-[118px] md:h-[33px] flex items-center justify-center"
              >
                <img
                  src="/assets/images/header/register.png"
                  alt="Đăng ký"
                  className="max-w-full max-h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1200px] mx-auto h-auto flex justify-center items-center">
        <img
          src="/assets/images/header/bannerpc.png"
          alt=""
          className="w-full h-auto object-contain md:flex hidden"
        />
        <img
          src="/assets/images/header/bannermb.png"
          alt=""
          className="w-full h-auto object-contain md:hidden flex"
        />
      </div>

      <div className="flex flex-row justify-center items-center w-full gap-2 sm:gap-4 lg:gap-6 md:py-3 py-0 px-2 -mt-1 md:mt-0">
        {navItems.map((item) => {
          const isActive = activeNav === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={`text-center min-w-[68px] text-[10px] md:text-[14px] font-semibold flex items-center justify-center transition-colors duration-200 w-auto h-[50px] bg-transparent`}
            >
              <img
                src={isActive ? item.iconActive : item.icon}
                alt="Lịch sử"
                className="w-full h-full object-contain"
              />
            </Link>
          );
        })}
        <button
          onClick={() => setIsModalHistory(true)}
          className="text-center text-[12px] md:text-[14px] font-semibold text-white hover:text-white/80 transition-colors duration-200 cursor-pointer border-none flex items-center justify-center w-auto h-[50px] bg-transparent"
        >
          <img
            src="/assets/images/header/btn_lichsu.png"
            alt="Lịch sử"
            className="w-full h-full object-contain"
          />
        </button>
      </div>
      {/* </div> */}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default HeaderMenu;
